
import { Component, Vue } from 'vue-property-decorator';
import { getReservationTypeList } from '@/api/reservationType';
import { getReservationCategoryList } from '@/api/reservationCategory';
import { deleteReservationItem, getReservationItemList } from '@/api/reservationItem';
import Pagination from '@/components/Pagination/index.vue';
import { UserModule } from '@/store/modules/user';
import PricePartForm from '@/views/stay/price/components/PricePartForm.vue';

@Component({
  components: {
    Pagination,
  },
})
export default class extends Vue {
  mounted() {
    this.init();
  }

  get industryIdx() {
    return UserModule.industry;
  }

  private listQuery: any = {
    typeUid: '',
    categoryUid: '',
    searchType: 'name',
    searchValue: '',
    page: 0,
    size: 10,
  }

  private typeList: any = [];

  private categoryList: any = []

  private itemList: any = [];

  private totalElements = 0;

  private loading = true;

  private init() {
    getReservationTypeList().then((res) => {
      this.typeList = res.data;
      if (res.data.length > 0) this.listQuery.typeUid = res.data[0].uid;
      this.getReservationCategoryList();
      this.getReservationItemList();
    });
  }

  private getReservationCategoryList() {
    getReservationCategoryList(this.listQuery.typeUid).then((res) => {
      this.categoryList = res.data;
    });
  }

  private getReservationItemList() {
    this.loading = true;
    getReservationItemList(this.listQuery).then((res) => {
      this.itemList = res.data.content;
      this.totalElements = res.data.totalElements;
      this.loading = false;
    });
  }

  private handleChangeType() {
    this.listQuery.categoryUid = '';
    this.getReservationCategoryList();
    this.getReservationItemList();
  }

  private handleClickUpdateService(item: any) {
    this.$router.push({
      name: 'ReserveItemUpdate',
      params: { uid: item.uid },
      query: { ...this.$route.query },
    });
  }

  private handleDeleteService(item: any) {
    this.$confirm(`정말 ${item.name}을(를) 삭제하시겠습니까?`, '예약 서비스 삭제', {
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
      type: 'error',
    }).then(() => {
      deleteReservationItem(item.uid).then(() => {
        this.$message.success('성공적으로 예약 서비스가 삭제되었습니다.');
        this.getReservationItemList();
      });
    });
  }

  private handleClickCopyService(item: any) {
    const item2 = {
      category: {
        name: '빵',
      },
      name: '남해유자빵',
      ranges: [
        {
          useStart: '2023-01-03',
          useEnd: '2023-01-03',
        },
      ],
      price: '20,000원',
    };
    this.itemList.push(item2);
  }

  private handleAddService() {
    this.$router.push({ name: 'ReserveItemAdd', query: { typeUid: this.listQuery.typeUid } });
  }

  private handleSearch() {
    this.listQuery.page = 0;
    this.getReservationItemList();
  }
}
